import { Brand, createBranded } from '@deltasierra/type-utilities';

export type EmailTemplateLayoutBlockId = Brand<string, 'EmailTemplateLayoutBlockId'>;
export const EmailTemplateLayoutBlockId = createBranded<EmailTemplateLayoutBlockId>();
